import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

interface FilterInputTextProps {
  iconPosition?: "left" | "right";
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}

export default function FilterInputText({ iconPosition, placeholder, value, onChange }: FilterInputTextProps) {
  return (
    <IconField iconPosition={iconPosition}>
      <InputIcon className={value && "pi pi-times cursor-pointer"} onClick={() => onChange?.("")} />
      <InputText placeholder={placeholder} value={value ?? ""} onChange={(e) => onChange?.(e.target.value)} />
    </IconField>
  );
}
